import React from 'react';

import { LandingPageTeaser } from '../../components/landing-page-teaser/LandingPageTeaser';
import { LandingPageMarketingCards } from '../../components/landing-page-marketing-cards/LandingPageMarketingCards';

export const LandingPage: React.FC = () => {
    return (
        <div>
            <LandingPageTeaser />
            <LandingPageMarketingCards />
        </div>
    );
};
